import { useState, useEffect } from 'react';

import { useGoogleLogin } from '@react-oauth/google';
import GoogleButton from 'react-google-button'


import { AuthLayout } from '../catalyst/auth-layout'
import { Button } from '../catalyst/button'
import { ErrorMessage, Field, Label } from '../catalyst/fieldset'
import { Heading } from '../catalyst/heading'
import InputWithError from '../catalyst/custom/inputWithError'
import { Strong, Text, TextLink } from '../catalyst/text'
import { Logo } from '../logo'

import LanguageSelector from '../language/LanguageSelector';
import { Trans, useTranslation } from "react-i18next";
import Spinning from '../components/spinning';
import { useNavigate, redirect } from 'react-router-dom';


import CheckCircleIcon from '@heroicons/react/24/solid/CheckCircleIcon';

import config from '../config';
import { Link } from 'react-router-dom';
import { set } from 'date-fns';



export function Terms(props) {
  return (
    <Text variant="body2" color="text.secondary" align="center" {...props}>
      {'By proceeding, you agree to '}
      <TextLink color="inherit" sx={{ fontWeight: 'bold', textDecoration: 'underline' }} href={config.termsPath}>
        our terms of service and privacy policy 
      </TextLink>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Text>
  );
}

// TODO remove, this demo shouldn't need to reset the theme.

export default function SignUp() {



  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [errResponse, setErrResponse] = useState("");

  const { t } = useTranslation(undefined, { keyPrefix: 'signup' });
  // const {greeting} = t("greeting", {channel: "RoadsideCoder"});

  const [submitting, setSubmitting] = useState(false)

  const [sentSuccessfully, setSentSuccessfully] = useState(false)

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
    acceptedTerms: true
  });

  ;

  const validate = (submittedFormData) => {
    let errors = {};

    if (!submittedFormData.name) {
      errors.name = t("nameRequired");
    }

    if (!submittedFormData.email) {
      errors.email = t("emailRequired");
    } else if (!/\S+@\S+\.\S+/.test(submittedFormData.email)) {
      errors.email = t("emailInvalid");
    }

    if (!submittedFormData.password) {
      errors.password = t("passwordRequired");
    } else if (submittedFormData.password.length < 6) {
      errors.password = t("passwordLengthError");
    }

    if (!submittedFormData.confirmPassword) {
      errors.confirmPassword = t("confirmRequired");
    } else if (submittedFormData.confirmPassword !== submittedFormData.password) {
      errors.confirmPassword = t("passwordsNotMatched");
    }

    return errors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    var formDataObj = new FormData(e.currentTarget);
    var newData = {
      name: formDataObj.get('name'),
      email: formDataObj.get('email'),
      password: formDataObj.get('password'),
      confirmPassword: formDataObj.get('confirmPassword'),
      acceptedTerms: true
    }
    setFormData(newData)
    const validationErrors = validate(newData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setErrors({});
      setSubmitting(true)
      fetch(config.apiUrl + "/user/create", { // Replace with your actual endpoint
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(newData)
      })
        .then(response => {
          setSubmitting(false)
          if (!response.ok) {
            if (response.status === 400) {
              return response.text().then(text => {
                throw new Error(t(text));
              });
            }
            throw new Error(t("registerError"));
          }
          return response.text();
        })
        .then(data => {
          setErrResponse(t(data));
          setSentSuccessfully(true)
          setErrors({});
        })
        .catch((error) => {
          setSubmitting(false)
          setErrResponse(error.message)
          setErrors({});
          console.error('Error:', error);
        });
    }
  };

  const googleLogin = useGoogleLogin({
    onSuccess: async tokenResponse => {
      navigate("/login/google/authenticate?code=" + tokenResponse.access_token)
    },
    // flow: 'implicit', // implicit is the default
  });


  function SignUpForm() {
    return (
      <form onSubmit={handleSubmit} className="grid w-full max-w-sm grid-cols-1 gap-8">
      <div className="flex flex-col items-center justify-center space-y-4">
      <Logo className="h-6 text-zinc-950 dark:text-white forced-colors:text-[CanvasText]" redirectHome={true}/>
      <GoogleButton onClick={() => googleLogin()} label="Login with Google"></GoogleButton>
      <Heading>{t("or")}</Heading>
      <Heading>{t("title")}</Heading>
      {/* <LanguageSelector></LanguageSelector> */}
      </div>
  
      
      <InputWithError error={errors.name} type="name" name="name" label={t("name")} onChange={()=>{}}/>
        <InputWithError error={errors.email} type="email" name="email" label={t("email")} onChange={()=>{}}/>
        <InputWithError error={errors.password} type="password" name="password" label={t("password")} onChange={()=>{}}/>
        <InputWithError error={errors.confirmPassword} type="password" name="confirmPassword" label={t("confirmPassword")} onChange={()=>{}}/>
  
        {errResponse && <Field><ErrorMessage>{errResponse}</ErrorMessage></Field>}
  
  
        <Button type="submit" className="w-full cursor-pointer"  disabled={submitting}>
            {submitting ? <Spinning /> : t("signup")}
        </Button>
  
        <div className="flex items-center justify-between">
        <Text className="ml-auto">
            {t("alreadyHaveAnAccount")}
            {' '}
            <TextLink href="login">
                <Strong>{t("login")}</Strong>
            </TextLink>
        </Text>
        </div>
        <Terms></Terms>
      </form>
    )
  }



  function SignupComfirmation() {
    return (
        <div className="grid w-full max-w-sm grid-cols-1 gap-8">
        <div className="flex flex-col items-center justify-center space-y-4">
        <Logo className="h-6 text-zinc-950 dark:text-white forced-colors:text-[CanvasText]" redirectHome={true}/>
        <Heading>Account activation email sent</Heading>
        <CheckCircleIcon className="h-30 w-30 text-green-500" aria-hidden="true" />

        <Text>
        We’ve emailed you a link to verify your email <Strong>{formData.email}</Strong>. Please check your inbox.
        </Text>
        

        </div>

        
        </div>
    );
}

  return (

    <AuthLayout>
        {!sentSuccessfully ? (<SignUpForm></SignUpForm>) : (<SignupComfirmation></SignupComfirmation>)}

  </AuthLayout>

  );
}